// ProfileWelcome.tsx — Shown on own profile when it has zero posts and zero followers.
// Encourages the user to make their first post.

import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ConsolePanel } from '@/ui';

// ─── Styled ───────────────────────────────────────────────────────────────────

const Card = styled(ConsolePanel)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 32px 24px;
  text-align: center;
`;

const Heading = styled.h2`
  margin: 0;
  font-family: ${({ theme }) => theme.font.display};
  font-size: ${({ theme }) => theme.fontSize.lg};
  font-weight: 700;
  color: ${({ theme }) => theme.color.textPrimary};
`;

const Body = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
  line-height: 1.55;
`;

const CtaLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: ${({ theme }) => theme.font.body};
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSize.sm};
  padding: 8px 20px;
  border-radius: ${({ theme }) => theme.radius.md};
  border: 1px solid transparent;
  text-decoration: none;
  background: ${({ theme }) => theme.color.accentCyan};
  color: ${({ theme }) => theme.color.onAccent};
  transition: transform 80ms ease, opacity 160ms ease;

  &:hover {
    opacity: 0.9;
  }
  &:active {
    transform: translateY(1px);
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.focusRing};
    outline-offset: 2px;
  }
`;

// ─── Component ────────────────────────────────────────────────────────────────

export function ProfileWelcome() {
  return (
    <Card>
      <Heading>Welcome to TruXSocial</Heading>
      <Body>Share your first thought to start building your presence.</Body>
      <CtaLink to="/">Make your first post</CtaLink>
    </Card>
  );
}
